import React from "react";
import "./styleMystyle.css";
import cutisHonour from "../assets/img/home/dr-bs-chandrashekar.jpg";
const AboutCutis = () => {
  return (
    <>
      <section className="abouthome" data-aos="fade-up">
        <div className="container" id="about-cutis-home">
          <div className="row">
            <div className="col-lg-7">
              <div className="card border-0">
                <div className="card-heading">
                  <h2>BEGINNING OF THE NEW AGE</h2>
                </div>
                <div
                  className="card-content row justify-content-center align-items-center"
                  data-aos="fade-up"
                >
                  <div className="col-md-5">
                    <div className="card-img text-center">
                      <img
                        src={cutisHonour}
                        alt="Not available"
                        className="img-fluid"
                      />
                      <h3 class="aboutContent docName text-center">
                        Dr B.S.Chandrashekar
                        <br />
                        <span class="single-line">
                          {/* Chief Dermatologist &amp; Medical Director */}
                          Chairman and Managing Director - Cutis Groups
                        </span>
                      </h3>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="card-titles">
                      <h5>Vision:</h5>
                      <p>
                        <strong>Cutis:</strong> Leader in dermatology, dedicated
                        to crafting exceptional care for skin, hair, and nails.
                      </p>
                      <p>
                        <strong>CACS:</strong> Epitome of care, education and
                        research.
                      </p>
                      <h5>Mission:</h5>
                      <p>
                        To provide patient-centric, ethical practice, delivering
                        high-quality clinical, surgical, and cosmetic care to
                        all under one roof, led by eminent dermatologists.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5" id="aboutCutisHome">
              <h2>ABOUT CUTIS</h2>
              <p className="font-italic">
                CUTIS Academy of Cutaneous Sciences (CACS) is the brainchild of
                Dr. B. S. Chandrashekar, an eminent clinician who is recognized
                internationally in the field of Dermatology. CUTIS initially
                started as a small clinic in 1997 and has grown into a
                full-fledged super-specialty skin institute. We have
                out-patients of more than 300+ per day.
              </p>
              <p className="font-italic">
                CACS is the pioneer in providing high-quality dermatology care
                and takes great pride in fulfilling educational, research, and
                community service missions with excellence. CACS is enriched by
                the laurels brought by the faculty members and students through
                their research publications, projects, fellowships, and
                community participation.
              </p>
              <a href="/about" class="learnMoreBtn">
                LEARN MORE
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="need-heading">
          <h2 className="text-center text-til my-3">CUTIS HOSPITAL TOUR</h2>
        </div>
        <div className="row" id="cutis-tour-video">
          <div className="col text-center">
            <div className="card">
              <iframe
                className="makeResponsiveVideoYoutube"
                // src="https://www.youtube-nocookie.com/embed/uWRmqpI0NWE?controls=0"
                srcdoc="<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/uWRmqpI0NWE/?autoplay=1><img src=https://img.youtube.com/vi/uWRmqpI0NWE/hqdefault.jpg alt='AltTagContent'><span>▶</span></a>"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutCutis;
